var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArticle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 64,
    viewBox: "0 0 61 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6312 51.4931V8.4264C12.6312 5.3424 15.1325 2.84106 18.2165 2.84106H52.4885C55.5819 2.84106 58.0885 5.34773 58.0885 8.44106V55.4051C58.0885 58.5504 55.5392 61.0997 52.3939 61.0997H8.95118C5.82852 61.0997 3.29785 58.5691 3.29785 55.4464V21.9917C3.29785 18.8837 5.82052 16.3651 8.92985 16.3717L11.2979 16.3757",
    stroke: "currentColor",
    strokeWidth: 4.69467,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.6895 14.8375H49.3788",
    stroke: "currentColor",
    strokeWidth: 4.75867,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3506 25.9598H49.3786",
    stroke: "currentColor",
    strokeWidth: 4.75867,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3506 37.0809H49.3786",
    stroke: "currentColor",
    strokeWidth: 4.75867,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3506 48.2023H49.3786",
    stroke: "currentColor",
    strokeWidth: 4.75867,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6496 18.9879H21.3496V10.6879H29.6496V18.9879Z",
    stroke: "currentColor",
    strokeWidth: 3.71467,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArticle);
export default __webpack_public_path__ + "static/media/article.f8f1663e5c9c51693e33044169c59832.svg";
export { ForwardRef as ReactComponent };